import * as React from 'react'

import { Box, Text } from '@factorialco/deprecated-design-system'
import { flattenDeep } from 'lodash'
import uniq from 'lodash/uniq'

import { observer } from 'mobx-react'

import i18n from 'modules/core/lib/i18n'

import { useCountCellsSelected } from 'modules/shift_management/hooks/useCountCellsSelected'
import { useEnabledFeatures } from 'modules/shift_management/hooks/useEnabledFeatures'
import { useSchedule } from 'modules/shift_management/hooks/useSchedule'
import { useSelectionState } from 'modules/shift_management/hooks/useSelection'
import type ShiftsRow from 'modules/shift_management/store/internal/models/ShiftsRow'

import ColorCode from './ColorCode'
import SelectionIndicator from './SelectionIndicator'

interface FooterProps {
  shiftsRows: ShiftsRow[]
}

const Footer = ({ shiftsRows }: FooterProps) => {
  const [{ hasFeatureFlag }] = useEnabledFeatures()
  const [{ view }] = useSchedule()
  const { daysByRow, allTableSelected } = useSelectionState()
  const canManage = shiftsRows.some((shiftsRow) => shiftsRow.canManage)
  const hasColors = hasFeatureFlag('shift_management_colours_for_shifts')
  const showContractHours = canManage

  const cellCount = useCountCellsSelected()
  // Filter only those rows with length
  const rowsSelectedCount = Object.values(daysByRow).filter((a) => a.length).length
  const listOfDays = flattenDeep(Object.values(daysByRow))
  const daysSelectedCount = uniq(listOfDays).length

  const countCopy = i18n.tp('employees.showing.items', {
    count: shiftsRows.length,
  })

  const plannedHoursLabel = i18n.t('shift_management.hours_information.planned_hours.label')
  const contractHoursLabel = i18n.t('shift_management.hours_information.contract_hours.label')

  const labelCopy = showContractHours
    ? `${plannedHoursLabel}, ${contractHoursLabel}`
    : plannedHoursLabel

  return (
    <Box
      paddingX="s24"
      paddingY="s12"
      gap="s8"
      flexDirection="row"
      flexGrow
      border={{
        all: {
          style: 'solid',
          width: 's1',
          color: 'grey300',
        },
      }}
      background="grey100"
    >
      <Box width="full" flexDirection="row" gap="s4" key={shiftsRows.length}>
        <Text.Normal size="100" weight="medium">
          {countCopy}
        </Text.Normal>
        {view.isByEmployees && (
          <Text.Normal size="100" weight="medium">
            - {labelCopy}
          </Text.Normal>
        )}
        <SelectionIndicator
          allTableSelected={allTableSelected}
          rowsSelectedCount={rowsSelectedCount}
          daysSelectedCount={daysSelectedCount}
          cellCount={cellCount}
          view={view}
        />
        {hasColors && <ColorCode />}
      </Box>
    </Box>
  )
}

export default observer(Footer)
